/**
 * Word counting utility for situation + answer text inputs.
 *
 * Spec: user input capped at 1000 words. We don't enforce a hard
 * character limit because the backend Cleaner already accepts up to
 * 50KB; the 1000-word limit is the UX constraint (see prompt_aadya.md
 * answer #18 of the third clarification batch).
 */

export const WORD_LIMIT = 1000

/**
 * Count words in a string. Uses a simple whitespace split; handles
 * tabs, newlines, and multiple spaces. Empty string returns 0.
 */
export function countWords(text: string): number {
  if (!text) return 0
  const trimmed = text.trim()
  if (!trimmed) return 0
  return trimmed.split(/\s+/).length
}

/**
 * Returns true if the text exceeds the spec word limit.
 */
export function isOverLimit(text: string, limit: number = WORD_LIMIT): boolean {
  return countWords(text) > limit
}
